import styled from 'styled-components';

export const Wrapper = styled.div`
    div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    div:first-of-type {
        justify-content: center;
        text-align: center;
    }
`;